import { FunctionComponent, useContext } from 'react';
import { Typography } from '@mui/material';
import { AppContext } from '../../providers/AppContext';
import useWindowDimensions from '../../hooks/dimension';

interface GitHubStreakProps {
    handleDrag: any;
    handleDrop: any;
    id: any;
}

const GitHubStreak: FunctionComponent<GitHubStreakProps> = (props: GitHubStreakProps) => {

    const { username } = useContext(AppContext);
    const { height, width } = useWindowDimensions();


    return (
        <div
            id={props.id}
            draggable={true}
            onDragStart={props.handleDrag}
            onDragOver={(e: any) => e.preventDefault()}
            onDrop={(e) => props.handleDrop(e, true)}
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                marginTop: 8
            }}
        >
            <Typography variant='h5' style={{
                marginBottom: 8,
            }}>GitHub Streak</Typography>

            {
                username ?
                    <div style={{
                        display: 'flex',
                        flexDirection : width && width < 600 ? 'column' : 'row',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <img src={`https://github-readme-streak-stats.herokuapp.com/?user=${username}&card_width=${width && width < 800 ? width - 60 : 495}`} alt={`${username}`} />
                    </div>
                    : <Typography> Please fill the github username first </Typography>
            }
        </div>
    );
}

export default GitHubStreak;